import FormattedMessage from 'I18n/components/FormattedMessage';
import { Heading, LayoutHorizontal } from 'breeze-intelligence-kit';
import { PoweredBy } from '../PoweredBy';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PanelHeader = () => /*#__PURE__*/_jsxs(LayoutHorizontal, {
  background: "background-color-light",
  borderBlockEnd: "border",
  insetBlockStart: "0",
  justifyContent: "space-between",
  paddingBlock: "space-md",
  paddingInline: "space-xl",
  position: "sticky",
  zIndex: 100,
  children: [/*#__PURE__*/_jsx(Heading, {
    as: "h5",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dataTest.panel.subtitle"
    })
  }), /*#__PURE__*/_jsx(PoweredBy, {})]
});